<template>
  <w-icon-wrapper
    :height="24"
    :width="24"
    view-box="0 0 24 24"
    icon-name="work-stock-icon"
  >
    <g
      id="_91_Lagerbestand"
      data-name="91 Lagerbestand"
      transform="translate(57.732 -0.212)"
    >
      <g
        id="Gruppe_25619"
        data-name="Gruppe 25619"
      >
        <path
          id="Pfad_55844"
          data-name="Pfad 55844"
          d="M-45.732.212a12,12,0,0,0-12,12,12,12,0,0,0,12,12,12,12,0,0,0,12-12A12,12,0,0,0-45.732.212Zm0,22a10.011,10.011,0,0,1-10-10,10.011,10.011,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.011,10.011,0,0,1-45.732,22.212Z"
          fill="currentColor"
        />
      </g>
      <g
        id="Gruppe_25620"
        data-name="Gruppe 25620"
      >
        <path
          id="Pfad_55845"
          data-name="Pfad 55845"
          d="M-38.768,17V13.21H-52.7V17h1.93V15.21h4.02V17h1.93V15.21h4.12V17Z"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4046"
          data-name="Rechteck 4046"
          width="6"
          height="6"
          transform="translate(-47.733 5.882)"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4047"
          data-name="Rechteck 4047"
          width="3.765"
          height="3.765"
          transform="translate(-52.733 8.117)"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4048"
          data-name="Rechteck 4048"
          width="2.006"
          height="2.006"
          transform="translate(-40.736 9.876)"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconStock' };
</script>
